/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PublishedDashboard } from '../models/published-dashboard';
@Injectable({
  providedIn: 'root',
})
class PublishedDashboardService extends __BaseService {
  static readonly PublishedDashboardGetPublicationsPath = '/api/PublishedDashboard/GetPublications';
  static readonly PublishedDashboardPublishPath = '/api/PublishedDashboard/Publish';
  static readonly PublishedDashboardUnPublishPath = '/api/PublishedDashboard/UnPublish';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `PublishedDashboardService.PublishedDashboardGetPublicationsParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardGetPublicationsResponse(params: PublishedDashboardService.PublishedDashboardGetPublicationsParams): __Observable<__StrictHttpResponse<Array<PublishedDashboard>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteUri != null) __params = __params.set('siteUri', params.siteUri.toString());
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/PublishedDashboard/GetPublications`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PublishedDashboard>>;
      })
    );
  }
  /**
   * @param params The `PublishedDashboardService.PublishedDashboardGetPublicationsParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardGetPublications(params: PublishedDashboardService.PublishedDashboardGetPublicationsParams): __Observable<Array<PublishedDashboard>> {
    return this.PublishedDashboardGetPublicationsResponse(params).pipe(
      __map(_r => _r.body as Array<PublishedDashboard>)
    );
  }

  /**
   * @param params The `PublishedDashboardService.PublishedDashboardPublishParams` containing the following parameters:
   *
   * - `validToo`:
   *
   * - `siteUri`:
   *
   * - `publishedToEmail`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardPublishResponse(params: PublishedDashboardService.PublishedDashboardPublishParams): __Observable<__StrictHttpResponse<PublishedDashboard>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.validToo != null) __params = __params.set('validToo', params.validToo.toString());
    if (params.siteUri != null) __params = __params.set('siteUri', params.siteUri.toString());
    if (params.publishedToEmail != null) __params = __params.set('publishedToEmail', params.publishedToEmail.toString());
    if (params.dashboardId != null) __params = __params.set('dashboardId', params.dashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/PublishedDashboard/Publish`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PublishedDashboard>;
      })
    );
  }
  /**
   * @param params The `PublishedDashboardService.PublishedDashboardPublishParams` containing the following parameters:
   *
   * - `validToo`:
   *
   * - `siteUri`:
   *
   * - `publishedToEmail`:
   *
   * - `dashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardPublish(params: PublishedDashboardService.PublishedDashboardPublishParams): __Observable<PublishedDashboard> {
    return this.PublishedDashboardPublishResponse(params).pipe(
      __map(_r => _r.body as PublishedDashboard)
    );
  }

  /**
   * @param params The `PublishedDashboardService.PublishedDashboardUnPublishParams` containing the following parameters:
   *
   * - `publishedDashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardUnPublishResponse(params: PublishedDashboardService.PublishedDashboardUnPublishParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.publishedDashboardId != null) __params = __params.set('publishedDashboardId', params.publishedDashboardId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/PublishedDashboard/UnPublish`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `PublishedDashboardService.PublishedDashboardUnPublishParams` containing the following parameters:
   *
   * - `publishedDashboardId`:
   *
   * - `customerId`:
   */
  PublishedDashboardUnPublish(params: PublishedDashboardService.PublishedDashboardUnPublishParams): __Observable<boolean> {
    return this.PublishedDashboardUnPublishResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module PublishedDashboardService {

  /**
   * Parameters for PublishedDashboardGetPublications
   */
  export interface PublishedDashboardGetPublicationsParams {
    siteUri?: null | string;
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for PublishedDashboardPublish
   */
  export interface PublishedDashboardPublishParams {
    validToo?: string;
    siteUri?: null | string;
    publishedToEmail?: null | string;
    dashboardId?: number;
    customerId?: number;
  }

  /**
   * Parameters for PublishedDashboardUnPublish
   */
  export interface PublishedDashboardUnPublishParams {
    publishedDashboardId?: number;
    customerId?: number;
  }
}

export { PublishedDashboardService }
